import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getBlogsById } from "store/actions";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
const SingleBlog = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [VideoBlog, setvideoBlog] = useState()
  const [blogsDetails, setblogsDetails] = useState()


  useEffect(() => {
    if (location.state) {
      setvideoBlog(location.state)
    }
  }, [location.state])
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const x = useSelector((state) => state?.home?.blogsDetails);
  useEffect(() => {
    setblogsDetails(x)
  }, [x]);
  useEffect(() => {
    dispatch(getBlogsById(id));
  }, [id]);

  useEffect(() => {
    if (VideoBlog) {
      // blogsDetails = VideoBlog
      setblogsDetails(VideoBlog)
    }
  }, [VideoBlog]);

  const backto = () => {
    window.history.back()
  }
  return (
    <section className="description-nft">
      <div className="container-fluid profileBox blogbg">
        <Row>
          <Col lg={12}>
            <h1><div className="d-inline cursor-pointer" onClick={backto}>BLOG</div> / <span> {blogsDetails?.title ? blogsDetails?.title : ''}</span></h1>

          </Col>
        </Row>
      </div>
      <Container>
        <Row>
          <Col lg={12}>
            <div className="viewlog text-start py-5">
              {/* <h2>{blogsDetails?.title || "Description of what are NFT’s"}</h2> */}
              <Row className="justify-content-center">
                {blogsDetails?.is_video_blog ? (
                  <Col lg="8">
                    <iframe className="videoBlogNew"
                      src={blogsDetails?.video_link}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </Col>
                ) : (
                  <Col lg="12">
                    <div className="blogImg text-center">
                      {blogsDetails?.image?.link && (
                        <img
                          src={
                            blogsDetails?.image.link || "images/Description-right.png"
                          }
                          alt=""
                          className="img-fluid"
                        />
                      )}
                    </div>
                  </Col>
                )}
              </Row>

              <p className="blogdate"><i className="fa-solid fa-calendar"></i> {blogsDetails?.date ? blogsDetails.date : (moment(blogsDetails?.date_created).format("DD  MMM yy"))} </p>
              <h4 className="">
                {blogsDetails?.subtitle ||
                  ""}
              </h4>
              {/* <p>{blogsDetails?.description}</p> */}
              <div className="blogcontentnew"
                dangerouslySetInnerHTML={{
                  __html: blogsDetails?.description || `<div className="d-flex align-items-center justify-content-center">
                  <p>Loading....</p>
                </div>`,
                }}
              />
              {blogsDetails?.blogNumber == 3 &&
                <div className="staticContent">
                  <h2>Section 1: Preparing Your Artwork</h2>
                  <p>The most crucial step in your Digital Artwork journey is having a high-quality digital file of your artwork. Here's how you can ensure you're ready to make the most of Terpnash:</p>
                  <h3>1.1. High-Quality Digital File:</h3>
                  <ul>
                    <li>Ensure that you have a high-resolution digital copy of your artwork. The better the quality, the more appealing it will be to potential buyers and collectors.</li>
                    <li>Accepted file formats include JPEG, PNG, GIF, or ???</li>
                    <li>Pay attention to details, color accuracy, and overall presentation to make your artwork stand out. </li>

                  </ul>
                  <h2>Section 2: Registering and Submitting Your Artwork</h2>
                  <p>Now that you have a digital copy of your artwork ready, it's time to submit your work with an Artist account. Follow these steps to get started:</p>
                  <h3>2.1. Access the Website:</h3>
                  <ul>
                    <li>Open your web browser and navigate to <Link to={'https://market.terpnash.com'}>market.terpnash.com</Link></li>
                  </ul>
                  <h3>2.2. Registration:</h3>
                  <ul>
                    <li>On the homepage, click on the <b>"Login/Register"</b> tab. This will initiate the registration process.</li>
                    <li>Select <b>"SignUp" </b> under the login tab</li>
                    <li>Click the <b>ARTIST</b> tab.</li>
                    <li>Provide all the required information, including your name, email address, profile picture, and a secure password.</li>
                    <li>Complete the registration by agreeing to the website's terms and conditions.</li>
                    <li>Verify your account through the email sent to the address you used to register.</li>
                    <li>For more detailed instructions on how to create an account as an ARTIST or USER, watch our walkthrough video at (link on website or YT?)</li>

                  </ul>
                  <h1>COMING SOON</h1>
                  <h3>2.3. Artist Submission</h3>
                  <ul>
                    <li>Once registered and logged in, navigate back to the homepage.</li>
                    <li>Click on the <b>"Artist Submission" </b> option. This will take you to the submission form.</li>
                  </ul>
                  <h3>2.4. Submission Form:</h3>
                  <ul>
                    <li>Fill out the submission form with accurate and detailed information about your artwork.</li>
                    <li>Include essential details such as the title, description, and any unique features or stories behind your artwork.</li>
                    <li>Upload your high-quality digital file of the artwork.</li>
                    <li>You may also include additional information with your submission such as behind-the-scenes images/videos of the creation process, video or audio recordings of the artist explaining their process, etc.</li>
                  </ul>
                  <h3>2.5. Submission Review:</h3>
                  <ul>
                    <li>After submitting your artwork and information, our team will review your submission.</li>
                    <li>Please allow 3-5 business days for this review process, as it ensures the quality and authenticity of the artwork on our platform.</li>
                  </ul>
                  <h2>Section 3: Approval and Next Steps</h2>
                  <p>Once your submission has been reviewed, you'll receive an approval or denial notification. Here's what you can do next:</p>
                  <h3>3.1. Approval:</h3>
                  <ul>
                    <li>If your submission is approved, you will receive a notification via email or within your account on our platform.</li>
                    <li>Log into your account to proceed to the next steps.</li>
                  </ul>
                  <h3>3.2. Denial: ????</h3>
                  <ul>
                    <li>In case of denial, don't be discouraged. Review the feedback provided and make necessary improvements to your submission.</li>
                    <li>You are welcome to resubmit your artwork once you've addressed any issues.</li>
                  </ul>
                  <h3>Conclusion:</h3>
                  <p>Congratulations! You've taken the first step toward becoming a part of the exciting Digital Artwork community on TERPNASH. By following this comprehensive guide, you've learned how to prepare your artwork, register on our platform, and submit your creation for review. Remember that the key to success in the Digital Artwork space is creating exceptional, high-quality art and engaging with your audience. Best of luck with your Digital Artwork journey, and we look forward to seeing your creativity on TERPNASH.</p>
                </div>
              }

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default SingleBlog;
